//import libraries
import { Component, OnInit,Input, AfterViewInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

//import constants
import { AppSettings } from '../../../../constants/app-settings';
import { AppPermissions } from '../../../../constants/app-permission';
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

//import services
import { AuthService } from '../../../../services/auth.service';
import { GeneralService } from '../../../../services/general.service';
import { NotificationService } from '../../../../services/notification.service';
import { ConfirmationDialogService } from '../../../general/modals/confirmation/confirmation.service';

import { CustomersService } from '../../../../services/customers.service';
import { SupplyersService } from '../../../../services/supplyers.service';

//import classes
import {
  UserMangActionAddEditIn, UserMangActionAddEditOut, UserMangActionUpdateOut, SubUserList
} from '../../../../classes/profile.model';

//import validators
import { ValidateExtension } from '../../../../validators/extension.validator';
import { ValidateUniqueEmail } from '../../../../validators/uniqueEmail.validator';
import { EmployeeService } from '../../../../services/employee.service';

declare var $: any;

@Component({
  selector: 'app-supplyer_create',
  templateUrl: './supplyer_create.component.html',
  styleUrls: ['./supplyer_create.component.css']
})
export class CreateSupplyerComponent implements OnInit, AfterViewInit {

  readonly AppSettings = AppSettings;
  readonly AppPermissions = AppPermissions;
  readonly AppFrontRoutes = AppFrontRoutes;
  @Input() langs: string;
  @Input() redirect: string;


  typeConfig: any;
  planConfig: any;
  emp_id: any;
  modalTitle: string;
  maintenance_plans: any;
  app_maintenance_plans: any;
  app_emp_id: any;
  lang: any;
  generalLang: any;
  record: any;
  mode: string;
  courseType: any;

  imageLink: any;
  data: any;
  skills_places: any;
  skills_places1: any;
  course: any;
  course_m: any;
  edit_data: any;
  id: any;
  redirect1: any;


  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};


  constructor(
    private formBuilder: FormBuilder,
    private generalService: GeneralService,
    private notificationService: NotificationService,
    private customersService: CustomersService,
    public bsModalRef: BsModalRef,
    private route: ActivatedRoute,
    private employeeService: EmployeeService,
    private supplyersService: SupplyersService,

    
    private router: Router) { }

  ngOnInit() {
    //fetch data
    this.data = this.route.snapshot.data['data'];
    //tab1 actions
    this.getData();
    this.config();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableCheckAll: true,
      itemsShowLimit: 3,
      allowSearchFilter: true
    };


  }

  ngAfterViewInit(): void {

    let tab = this.route.snapshot.paramMap.get('tab');

    if (tab)
      $('.nav-tabs a[href="#settingsTab"]').tab('show');

  }



  config(): void {
    this.courseType = [
      { value: '1', text: 'Internal Course' },
      { value: '2', text: 'External Course' },
      { value: '3', text: 'Training' },
    ];
  }



  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      code: ['', [Validators.required]],
      b_name: ['', [Validators.required]],
      address: ['', [Validators.required]],
      zip_code: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      tax_code: ['', [Validators.required]],
      fiscal_code: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      website: ['', [Validators.required]],
      macro_sector: ['', [Validators.required]],
      send_email: this.formBuilder.array([this.newEmail()]),
      attachments: this.formBuilder.array([this.newAttachment1()]),
      attachments_uploaded: this.formBuilder.array([]),
      cid: '',
      submit: 'update',
    });

    setTimeout(() => this.fileDesign(), 10);

    setTimeout(() => this.fileDesign(), 10);

    this.attachments().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });

    this.attachments_uploaded().valueChanges.subscribe(values => {
      setTimeout(() => this.fileDesign(), 10);
    });


  }



  FormBuildUpdate(): void {

    this.emptyEmail();
    let emails = this.edit_data.email.split(',');
    let images = this.edit_data.attachments.split(',');
    
    // console.log(this.edit_data.code);

    this.createForm.patchValue({
      code: this.edit_data.code,
      b_name: this.edit_data.bussines_name,
      address: this.edit_data.address,
      zip_code: this.edit_data.zip_code,
      city: this.edit_data.city,
      province: this.edit_data.province,
      tax_code: this.edit_data.tax_code,
      fiscal_code: this.edit_data.fiscal_code,
      phone: this.edit_data.phone,
      website: this.edit_data.website,
      macro_sector: this.edit_data.macro_sector,
      cid: this.edit_data.customersId,
      submit: 'update',
    });

    // console.log(emails);

    if (this.edit_data.email) {
      for (const email of emails) {
        this.send_email().push(this.newEmail(email));
      }
    }
    else
      this.send_email().push(this.newEmail());



    if (this.edit_data.attachments) {
      for (const uimage of images) {
        this.attachments_uploaded().push(new FormControl(uimage.split('/').pop()));
      }
    }

  }


  attachments(): FormArray {
    return this.createForm.get('attachments') as FormArray;
  };

  service_image_exists(): FormArray {
    return this.createForm.get('service_image_exists') as FormArray;
  };


  attach_exists(): FormArray {
    return this.createForm.get('attach_exists') as FormArray;
  };

  // fileupload(): FormArray {
  //   return this.createForm.get('fileupload') as FormArray;
  // };

  // teacher(): FormArray {
  //   return this.createForm.get('teacher') as FormArray;
  // };


  newAttachment1(): FormGroup {
    return this.formBuilder.group({
      link: ['']
    });
  }

  newAttachment(): FormGroup {
    return this.formBuilder.group({
      link: ['', [ValidateExtension(['jpg', 'jpeg', 'png'])]]
    });
  }

  addAttachment(): void {
    this.attachments().push(this.newAttachment1());
  }

  removeAttachment(i: number) {
    this.attachments().removeAt(i);
  }
  // addAttachment(): void {
  //   this.teacher().push(this.newAttachment1());
  // }

  // removeAttachment(i: number) {
  //   this.teacher().removeAt(i);
  // }

  // timetable_link_uploaded(): FormArray {
  // return this.createForm.get('timetable_link_uploaded') as FormArray;
  // };

  // removeAttachmentUploaded(i: number) {
  // this.timetable_link_uploaded().removeAt(i);
  // }

  attachments_uploaded(): FormArray {
    return this.createForm.get('attachments_uploaded') as FormArray;
  };

  removeAttachmentUploaded(i: number) {
    this.attachments_uploaded().removeAt(i);
  }

  service_image_uploaded(): FormArray {
    return this.createForm.get('service_image_uploaded') as FormArray;
  };

  removeAttachmentUploaded1(i: number) {
    this.service_image_uploaded().removeAt(i);
  }

  send_email(): FormArray {
    return this.createForm.get("send_email") as FormArray
  }

  newEmail(data = ''): FormControl {
    return new FormControl(data, [Validators.required,Validators.email]);
  }

  addEmail() {
    this.send_email().push(this.newEmail());
  }

  removeEmail(i: number) {
    this.send_email().removeAt(i);
  }

  emptyEmail() {
    while (this.send_email().controls.length > 0) {
      this.send_email().removeAt(0);
    }
  }


  public selectAttachment1(event: any, index) {

    this.createForm.value.attachments[index].link = File;

    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      let reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.createForm.value.attachments[index].link = { 'name': file.name, 'image': reader.result };
      };
    }

  }


  // public selectAttachment(event: any, index) {

  //   this.createForm.value.fileupload[index].link = File;

  //   if (event.target.files.length > 0) {
  //     const file = event.target.files[0];

  //     let reader = new FileReader();
  //     reader.readAsDataURL(file);

  //     reader.onload = () => {
  //       this.createForm.value.fileupload[index].link = { 'name': file.name, 'image': reader.result };
  //     };
  //   }

  // }


  // public selectAttachment1(event: any, index) {

  //   this.createForm.value.teacher[index].link = File;

  //   if (event.target.files.length > 0) {
  //     const file = event.target.files[0];

  //     let reader = new FileReader();
  //     reader.readAsDataURL(file);

  //     reader.onload = () => {
  //       this.createForm.value.teacher[index].link = { 'name': file.name, 'image': reader.result };
  //     };
  //   }

  // }

  fileDesign() {
    $(".filestyle").filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
  }

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }



  onSubmit() {

    this.createFormSubmitted = true;

    if (this.createForm.invalid)
      return;

    this.supplyersService.updateSupplyer(this.createForm.value).subscribe(
      res => {

        this.bsModalRef.hide();

        if (res.status) {
          this.generalService.notify_msg('success', res.msg);
          this.bsModalRef.hide();

          if (this.redirect1 == "") {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SUPPLYERS]);
              });
          }
          else {
            this.router.navigateByUrl('/test', { skipLocationChange: true })
            .then(() => {
              this.router.navigate([AppFrontRoutes.CUSTOMERS_VIEW + '/' + this.id]);
            });
          }
        }
        else {
          this.generalService.notify_msg('error', res.msg);
          this.bsModalRef.hide();
        }

      }
    );

  }




  getData() {
    // this.lang = this.notificationService.GeneralGetLangData(this.data);
    // this.route.params.subscribe(params => {
    //   this.id = params.id;

      if (this.id != undefined) {
        this.supplyersService.SupplyersEdit(this.id)
          .subscribe(
            (res) => {

              // console.log(res); return false;
              this.lang = this.supplyersService.listLang(res);

              this.edit_data = res.data.edit_data;
              this.modalTitle = this.lang.editsupplyer;
             
            

              // this.createFormErrorMsg = {
              //   'code': [{ type: 'required', message: this.lang.requiredField }],
              //   'b_name': [{ type: 'required', message: this.lang.requiredField }],
              //   'address': [{ type: 'required', message: this.lang.requiredField }],
              //   'zip_code': [{ type: 'required', message: this.lang.requiredField }],
              //   'city': [{ type: 'required', message: this.lang.requiredField }],
              //   'province': [{ type: 'required', message: this.lang.requiredField }],
              //   'tax_code': [{ type: 'required', message: this.lang.requiredField }],
              //   'fiscal_code': [{ type: 'required', message: this.lang.requiredField }],
              //   'phone': [{ type: 'required', message: this.lang.requiredField }],
              //   'website': [{ type: 'required', message: this.lang.requiredField }],
              //   'macro_sector': [{ type: 'required', message: this.lang.requiredField }],
              //   'send_email': [
              //     { type: 'required', message: this.lang.requiredField },
              //     { type: 'email', message: 'Please enter correct email format' }
              //   ],
              // }


              this.FormBuildUpdate();

            });
        // this.FormBuild();
        this.lang = this.langs;
        this.redirect1 = this.redirect;

        this.modalTitle = this.lang.editsupplyer;
      }
      else {
        // this.customersService.getCustomerList()
        //   .subscribe(
        //     (res) => {
        //       // this.lang = this.customersService.listLang(res);
        //       this.modalTitle = this.lang.createNew;
        //     });
               
        this.lang = this.langs;
        this.redirect1 = this.redirect;

        this.modalTitle = this.lang.supplyer;
       
      }
  
    // console.log(this.lang.requiredField);

   
        

      this.createFormErrorMsg = {
        'code': [{ type: 'required', message: this.lang.requiredField }],
        'b_name': [{ type: 'required', message: this.lang.requiredField }],
        'address': [{ type: 'required', message: this.lang.requiredField }],
        'zip_code': [{ type: 'required', message: this.lang.requiredField }],
        'city': [{ type: 'required', message: this.lang.requiredField }],
        'province': [{ type: 'required', message: this.lang.requiredField }],
        'tax_code': [{ type: 'required', message: this.lang.requiredField }],
        'fiscal_code': [{ type: 'required', message: this.lang.requiredField }],
        'phone': [{ type: 'required', message: this.lang.requiredField }],
        'website': [{ type: 'required', message: this.lang.requiredField }],
        'macro_sector': [{ type: 'required', message: this.lang.requiredField }],
        'send_email': [
          { type: 'required', message: this.lang.requiredField },
          { type: 'email', message: 'Please enter correct email format' }
        ],
      }
    
      this.FormBuild();
  }
}
